import { Directive, HostListener, inject } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appAlphanumericOnlyInput]',
  standalone: true,
})
export class AlphanumericOnlyInputDirective {
  private readonly ngControl = inject(NgControl, { optional: true });
  private readonly allowedPattern = /^[a-zA-Z0-9 ]$/;

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    // Allow control keys: backspace, delete, tab, escape, enter, arrows, home, end
    const controlKeys = [
      'Backspace',
      'Delete',
      'Tab',
      'Escape',
      'Enter',
      'ArrowLeft',
      'ArrowRight',
      'ArrowUp',
      'ArrowDown',
      'Home',
      'End',
    ];

    if (controlKeys.includes(event.key)) {
      return;
    }

    // Allow Ctrl/Cmd + A, C, V, X (select all, copy, paste, cut)
    if (
      (event.ctrlKey || event.metaKey) &&
      ['a', 'c', 'v', 'x'].includes(event.key.toLowerCase())
    ) {
      return;
    }

    // Block if the key is not alphanumeric or space
    if (!this.allowedPattern.test(event.key)) {
      event.preventDefault();
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    event.preventDefault();
    const pastedText = event.clipboardData?.getData('text') || '';
    const filteredText = pastedText.replaceAll(/[^a-zA-Z0-9 ]/g, '');

    const input = event.target as HTMLInputElement;
    const start = input.selectionStart || 0;
    const end = input.selectionEnd || 0;
    const currentValue = input.value;

    const newValue = currentValue.substring(0, start) + filteredText + currentValue.substring(end);
    input.value = newValue;

    if (this.ngControl?.control) {
      this.ngControl.control.setValue(newValue, { emitEvent: false });
    }

    // Set cursor position after pasted text
    const newCursorPos = start + filteredText.length;
    input.setSelectionRange(newCursorPos, newCursorPos);
  }

  @HostListener('input', ['$event'])
  onInput(event: Event) {
    const input = event.target as HTMLInputElement;
    const filteredValue = input.value.replaceAll(/[^a-zA-Z0-9 ]/g, '');

    if (filteredValue !== input.value) {
      input.value = filteredValue;
      if (this.ngControl?.control) {
        this.ngControl.control.setValue(filteredValue, { emitEvent: false });
      }
    }
  }
}
